import { addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';
import navLocaleData from '@99designs/common/apps/global-nav/locale-data/de';
import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';

setNavTranslations(navLocaleData);
addLocaleData(de);



// WEBPACK FOOTER //
// ./src/js/locale-data/de.js